import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('private_exchange', '/private_exchanges')
const actions = generator.generate()

export default actions
